<template>
  <v-container fluid class="container-page">
    <v-row align="center" justify="end">
      <v-col cols="3" md="3" lg="3" class="text-title-container">
        <span class="text-title text-primary">Realtime</span>
      </v-col>
      <v-col cols="9" md="9" lg="9" align="right">
        <span class="p-r-10 datetime">
          Today : {{ datetime | datetimeFormatWithSeconds }}
        </span>
      </v-col>
    </v-row>

    <v-row>
      <v-col
        v-if="
          (viewVoice() || viewAll()) && (viewInbound() || viewDirectionAll())
        "
        sm="12"
        :lg="viewOutbound() || viewDirectionAll() ? 6 : 12"
        class="text-title-container"
      >
        <v-card outlined :elevation="5">
          <v-row>
            <v-col>
              <v-card
                class="no-shadow"
                @click="
                  viewConver({
                    from,
                    to,
                    direction: directionInbound,
                    type: 'voice'
                  })
                "
              >
                <widget-voice-session
                  :refresh="trigger.voiceSession"
                  :direction="directionInbound"
                  @reset="resetTrigger"
                />
              </v-card>
            </v-col>
            <v-divider vertical></v-divider>
            <v-col>
              <v-card
                class="no-shadow"
                @click="
                  viewConver({
                    from,
                    to,
                    direction: directionInbound,
                    type: 'voice',
                    group: 'session-success'
                  })
                "
              >
                <widget-voice-session-success
                  :refresh="trigger.voiceSessionSuccess"
                  :direction="directionInbound"
                  @reset="resetTrigger"
                />
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-col>

      <v-col
        v-if="
          (viewVoice() || viewAll()) && (viewOutbound() || viewDirectionAll())
        "
        sm="12"
        :lg="viewInbound() || viewDirectionAll() ? 6 : 12"
        class="text-title-container"
      >
        <v-card outlined :elevation="5">
          <v-row>
            <v-col>
              <v-card
                v-if="noCampaign"
                class="no-shadow"
                @click="
                  viewConver({
                    from,
                    to,
                    direction: directionOutbound,
                    type: 'voice'
                  })
                "
              >
                <widget-voice-session
                  :refresh="trigger.voiceSession"
                  :direction="directionOutbound"
                  @reset="resetTrigger"
                />
              </v-card>
              <v-card v-else class="no-shadow">
                <widget-voice-call
                  :refresh="trigger.voiceCall"
                  @reset="resetTrigger"
                />
              </v-card>
            </v-col>
            <v-divider vertical></v-divider>
            <v-col>
              <v-card
                v-if="noCampaign"
                class="no-shadow"
                @click="
                  viewConver({
                    from,
                    to,
                    direction: directionOutbound,
                    type: 'voice',
                    group: 'session-success'
                  })
                "
              >
                <widget-voice-session-success
                  :refresh="trigger.voiceSessionSuccess"
                  :direction="directionOutbound"
                  @reset="resetTrigger"
                />
              </v-card>
              <v-card
                v-else
                class="no-shadow"
                @click="
                  viewConver({
                    from,
                    to,
                    direction: directionOutbound,
                    type: 'voice'
                  })
                "
              >
                <widget-voice-answered-call
                  :refresh="trigger.voiceAnsweredCall"
                  @reset="resetTrigger"
                />
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-col>

      <v-col v-if="viewChat() || viewAll()" sm="12" lg="12">
        <v-card outlined :elevation="5">
          <v-row>
            <v-col>
              <v-card
                class="no-shadow"
                @click="viewConver({ from, to, direction, type: 'chat' })"
              >
                <widget-chat-session
                  :refresh="trigger.chatSession"
                  :direction="directionInbound"
                  @reset="resetTrigger"
                />
              </v-card>
            </v-col>
            <v-divider vertical></v-divider>
            <v-col>
              <v-card
                class="no-shadow"
                @click="
                  viewConver({
                    from,
                    to,
                    directionInbound,
                    type: 'chat',
                    group: 'session-success'
                  })
                "
              >
                <widget-chat-session-success
                  :refresh="trigger.chatSessionSuccess"
                  :direction="directionInbound"
                  @reset="resetTrigger"
                />
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="8">
        <time-serie-active
          :class="
            viewVoice() || viewChat() ? 'dynamic-height' : 'dynamic-height1'
          "
          :refresh="trigger.timeSerieActive"
          :view-type="viewType"
          :direction="directionInbound"
          @reset="resetTrigger"
        />
      </v-col>
      <v-col cols="4">
        <tag-cloud-table
          v-if="tagCloudType === 'table'"
          :class="
            viewVoice() || viewChat() ? 'dynamic-height' : 'dynamic-height1'
          "
          :refresh="trigger.tagCloud"
          @reset="resetTrigger"
        />
        <tag-cloud
          v-else
          :class="
            viewVoice() || viewChat() ? 'dynamic-height' : 'dynamic-height1'
          "
          :refresh="trigger.tagCloud"
          @reset="resetTrigger"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Moment from 'moment'

import Vue from 'vue'
import vueSocketIO from 'vue-socket.io'

import WidgetVoiceSession from './components/widget_voice_session'
import WidgetVoiceSessionSuccess from './components/widget_voice_session_success'

import WidgetVoiceCall from './components/voice_outbound/widget_voice_call'
import WidgetVoiceAnsweredCall from './components/voice_outbound/widget_voice_answered_call'

import WidgetChatSession from './components/widget_chat_session'
import WidgetChatSessionSuccess from './components/widget_chat_session_success'

// import WidgetActive from './components/widget_active'
import TimeSerieActive from './components/time_serie_active'
import TagCloud from './components/tag_cloud'
import TagCloudTable from './components/tag_cloud_table'

Vue.use(
  new vueSocketIO({
    debug: process.env.VUE_APP_DEBUG_SOCKET_BACKEND_CONNECTION == 'true',
    connection: process.env.VUE_APP_CORE_BACKEND
  })
)

export default {
  name: 'Realtime',
  components: {
    WidgetVoiceSession,
    WidgetVoiceSessionSuccess,
    WidgetVoiceCall,
    WidgetVoiceAnsweredCall,
    WidgetChatSession,
    WidgetChatSessionSuccess,
    // WidgetActive,
    TimeSerieActive,
    TagCloud,
    TagCloudTable
  },
  data() {
    return {
      viewDirection: process.env.VUE_APP_DIRECTION,
      viewType: process.env.VUE_APP_TYPE,
      tagCloudType: process.env.VUE_APP_TAG_CLOUD_TYPE,
      interval: null,
      datetime: new Date(),
      format: 'YYYY-MM-DD HH:mm',
      from: '',
      to: '',
      directionInbound: 'inbound',
      directionOutbound: 'outbound',
      refresh: 0,
      intervalTagCloud: 15,
      lastTagcloud: null,
      trigger: {
        voiceSession: false,
        voiceSessionSuccess: false,
        voiceCall: false,
        voiceAnsweredCall: false,
        chatSession: false,
        chatSessionSuccess: false,
        timeSerieActive: false,
        tagCloud: false
      },
      noCampaign: process.env.VUE_APP_NO_CAMPAIGN === 'true'
    }
  },
  mounted() {
    this.interval = setInterval(() => {
      this.datetime = Moment()

      const sec = this.datetime.format('ss')
      const isTrig = sec % this.intervalTagCloud === 0
      if (
        isTrig &&
        !this.trigger.tagCloud &&
        Moment(this.datetime).diff(Moment(this.lastTagcloud), 'seconds') >= 5
      ) {
        this.lastTagcloud = this.datetime
        this.trigger.tagCloud = true
      }
    }, 1000)
  },
  created() {
    this.viewDirection =
      this.$route.query.direction || process.env.VUE_APP_DIRECTION
    this.viewType = this.$route.query.type || process.env.VUE_APP_TYPE
    this.tagCloudType =
      this.$route.query.tagCloudType || process.env.VUE_APP_TAG_CLOUD_TYPE
    this.noCampaign = this.$route.query.noCampaign
      ? this.$route.query.noCampaign === 'true'
      : process.env.VUE_APP_NO_CAMPAIGN === 'true'

    document.title = this.$t('page-title.realtime', {
      productName: this.$options.filters.getVariable('product_name')
    })

    this.trigger.voiceSession = true
    this.trigger.voiceSessionSuccess = true
    this.trigger.voiceCall = true
    this.trigger.voiceAnsweredCall = true
    this.trigger.chatSession = true
    this.trigger.chatSessionSuccess = true
    this.trigger.timeSerieActive = true
    this.trigger.tagCloud = true
    this.lastTagcloud = Moment()

    this.from = Moment()
      .startOf('day')
      .format(this.format)
    this.to = Moment()
      .add(1, 'days')
      .startOf('day')
      .format(this.format)
  },
  destroyed() {
    clearInterval(this.interval)
  },
  sockets: {
    connect: function() {
      // console.log('connect')
    },
    trigger: async function(data) {
      // this.refresh += 1
      if (!this.trigger.voiceSession) this.trigger.voiceSession = true
      if (!this.trigger.voiceSessionSuccess)
        this.trigger.voiceSessionSuccess = true
      if (!this.trigger.voiceCall) this.trigger.voiceCall = true
      if (!this.trigger.voiceAnsweredCall) this.trigger.voiceAnsweredCall = true
      if (!this.trigger.chatSession) this.trigger.chatSession = true
      if (!this.trigger.chatSessionSuccess)
        this.trigger.chatSessionSuccess = true
      if (!this.trigger.timeSerieActive) this.trigger.timeSerieActive = true
      // if (
      //   !this.trigger.tagCloud &&
      //   Moment().diff(Moment(this.lastTagcloud), 'seconds') >= 15
      // ) {
      //   this.lastTagcloud = Moment()
      //   this.trigger.tagCloud = true
      // }
    }
  },
  methods: {
    viewVoice() {
      return this.viewType === 'voice'
    },
    viewChat() {
      return this.viewType === 'chat'
    },
    viewAll() {
      return this.viewType === 'all'
    },
    viewInbound() {
      return this.viewDirection === 'inbound'
    },
    viewOutbound() {
      return this.viewDirection === 'outbound'
    },
    viewDirectionAll() {
      return this.viewDirection === 'all'
    },
    resetTrigger(widget) {
      this.trigger[widget] = false
    },
    viewConver(query) {
      let routeData = this.$router.resolve({
        path: '/conversations',
        query
      })
      window.open(routeData.href, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
.datetime {
  color: #222222;
}

.dynamic-height {
  height: calc(100vh - 299px);
}

.dynamic-height1 {
  height: calc(100vh - 465px);
}

.no-shadow {
  box-shadow: none !important;
}
</style>
